import { render, staticRenderFns } from "./RestaurantSettings.vue?vue&type=template&id=36df2a57&"
import script from "./RestaurantSettings.vue?vue&type=script&lang=ts&"
export * from "./RestaurantSettings.vue?vue&type=script&lang=ts&"
import style0 from "./RestaurantSettings.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports